export function isMessageNotification(notification) {
    return (notification.kind === "direct_notification" ||
        notification.kind === "group_notification" ||
        notification.kind === "channel_notification");
}
